import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { AuthService } from "../services/auth.service";
import { inject } from "@angular/core";
import { environment } from "@/environments/environment";

export function apiInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const authService = inject(AuthService);

  // We intercept all outgoing requests and check if it's going to /api
  // If so, we add the base api url to the request and the auth bearer token
  if (req.url.startsWith('/api')) {
    const baseUrl = environment.apiUrl;
    const apiUrl = req.url.replace('/api', '');
    const clonedReq = req.clone({
      url: `${baseUrl}${apiUrl}`,
      setHeaders: {
        Authorization: `Bearer ${authService.userTokens().accessToken}`
      }
    });
    return next(clonedReq);
  }

  return next(req);
}
